export default __webpack_public_path__ + "static/media/partner-cukaricki.b292f919.webp";